import type { FunctionComponent } from 'react';
import { SchoolsAccordionTable } from '../../../../../app-kit/components/SchoolsAccordionTable/SchoolsAccordionTable';
import { useSchoolPageBySlugTabContentQuery } from '../../../../graphql/useSchoolPageBySlugTabContentQuery';
import { isContentOverview } from '../../../../helpers/isContentOverview';
import { NearbySchoolsBrick } from './NearbySchoolsBrick';
import type { School } from '../../../../../app-kit/components/SchoolsAccordionTable/types';
import { AccordionInteraction } from '../../../../../analytics/event-tracking/trackAccordionInteraction';
import { mapWebLink } from '../../../../../app-kit/components/DynamicContent/helpers/mapDynamicContentItem';

export const NearbySchoolsBrickWithData: FunctionComponent = () => {
  const { data } = useSchoolPageBySlugTabContentQuery();
  const tabContent = data?.schoolPageBySlug?.tabContent;
  if (!tabContent || !isContentOverview(tabContent)) return null;

  const { nearbySchools } = tabContent;
  if (!nearbySchools) return null;
  const { title, schools, schoolFactHeader } = nearbySchools;

  // Transform the schools data to ensure tracking.user_action matches the AccordionInteraction enum
  const transformedSchools: School[] = (schools ?? []).map(({ webLinks, ...school }) => ({
    webLinks: webLinks?.map(mapWebLink),
    ...school,
    tracking: {
      expand: school.tracking.expand
        ? {
            ...school.tracking.expand,
            data: {
              ...school.tracking.expand.data,
              // Map string value to enum
              user_action:
                school.tracking.expand.data.user_action === 'expand'
                  ? AccordionInteraction.expand
                  : AccordionInteraction.collapse,
            },
          }
        : null,
      collapse: school.tracking.collapse
        ? {
            ...school.tracking.collapse,
            data: {
              ...school.tracking.collapse.data,
              // Map string value to enum
              user_action:
                school.tracking.collapse.data.user_action === 'expand'
                  ? AccordionInteraction.expand
                  : AccordionInteraction.collapse,
            },
          }
        : null,
    },
  }));

  return (
    <NearbySchoolsBrick title={title ?? ''}>
      <SchoolsAccordionTable
        schools={transformedSchools}
        schoolFactHeader={schoolFactHeader ?? []}
      />
    </NearbySchoolsBrick>
  );
};
